import { render, staticRenderFns } from "./FriendSelector.vue?vue&type=template&id=dae55190&scoped=true&"
import script from "./FriendSelector.vue?vue&type=script&lang=ts&"
export * from "./FriendSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FriendSelector.vue?vue&type=style&index=0&id=dae55190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae55190",
  null
  
)

export default component.exports